import { render, staticRenderFns } from "./TaskActivity.vue?vue&type=template&id=528c8f3c&scoped=true"
import script from "./TaskActivity.vue?vue&type=script&lang=js"
export * from "./TaskActivity.vue?vue&type=script&lang=js"
import style0 from "./TaskActivity.vue?vue&type=style&index=0&id=528c8f3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528c8f3c",
  null
  
)

export default component.exports